import useMutation from "../useMutation";

export default function useDebtReportCreate() {
  return useMutation({
    path: "/api/v1/reports",
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/reports`,
      shouldRevalidate: true,
    },
  });
}
